<section class="account-page" id="container">
  <app-menu></app-menu>
  <section id="main-content">
    <section class="wrapper">
      <h3 i18n="user account page title|The title of the user account page shown to authenticated users@@userAccountPageTitle">User account</h3>
      <div class="page-content error-wrapper" *ngIf="error">
        <div class="alert alert-danger">{{ error.message }}</div>
        <pre style="display: none">{{ error.stack }}</pre>
      </div>
      <div class="page-content loading-wrapper" *ngIf="!user && !error">
        <i class="fa fa-circle-o-notch fa-spin fa-5x"></i>
      </div>
      <div class="page-content" *ngIf="user && !error">
        <div class="row row-with-top-margin">
          <div class="border-panel information-table col-5">
            <div class="panel-header">
              <label
                class="border-panel-label"
                i18n="personal details title|The title of the block with personal details such as name, phone, country in the my account page@@personalDetailsAccountTitle"
              >Personal Details</label>
              <button class="btn btn-primary btn-xs" *ngIf="!editingPersonalDetails" (click)="onEditPersonalDetailsClick()"><i class="fa fa-pencil"></i></button>
              <button class="btn btn-danger btn-xs" *ngIf="editingPersonalDetails" [disabled]="isSavingPersonalDetails" (click)="onClosePersonalDetailsClick()"><i class="fa fa-close"></i></button>
            </div>
            <div class="border-panel-content">
              <app-personal-details-form
                [user]="user"
                [isEditState]="editingPersonalDetails"
                [isFormDisabled]="isSavingPersonalDetails"
                [isFormLoading]="isSavingPersonalDetails"
                (saveRequest)="onSavePersonalDetailsRequest($event)"
                (closeRequest)="onClosePersonalDetailsClick()"
              ></app-personal-details-form>
            </div>
          </div>
          <div class="border-panel email-configuration col-5">
            <div class="panel-header">
              <label
                class="border-panel-label"
                i18n="@@emailConfigurationFormAccountTitle"
              >Outgoing Mail Configuration</label>
              <button class="btn btn-primary btn-xs" *ngIf="!editingEmailConfiguration" (click)="onEditEmailConfigurationClick()"><i class="fa fa-pencil"></i></button>
              <button class="btn btn-danger btn-xs" *ngIf="editingEmailConfiguration" [disabled]="isSavingEmailConfiguration" (click)="onCloseEmailConfigurationClick()"><i class="fa fa-close"></i></button>
            </div>
            <div class="border-panel-content">
              <app-email-configuration-form
                [user]="user"
                [isEditState]="editingEmailConfiguration"
                [isFormDisabled]="isSavingEmailConfiguration"
                [isFormLoading]="isSavingEmailConfiguration"
                (saveRequest)="onSaveEmailConfigurationRequest($event)"
                (closeRequest)="onCloseEmailConfigurationClick()"
              ></app-email-configuration-form>
            </div>
          </div>
        </div>
        <div class="row row-with-top-margin">
          <div class="border-panel col-10" style="max-width: 84.5%; flex-basis: 84.5%;">
            <div class="panel-header">
              <label class="border-panel-label" i18n="actions title|The title of the block with actions with buttons such as edit account, change password and setup connection in the my account page@@actionsGroupAccountTitle">Actions</label>
            </div>
            <div class="border-panel-content">
              <div>
                <button
                  role="button"
                  type="button"
                  class="btn btn-info"
                  [disabled]="editingPersonalDetails"
                  (click)="onEditPersonalDetailsClick()"
                  i18n="edit account button label|The label inside the actions element group to open the edit account form in the My Account page@@editAccountPageButtonLabel"
                >Edit Personal Details</button>
                <button
                  role="button"
                  type="button"
                  class="btn btn-info"
                  [disabled]="editingEmailConfiguration"
                  (click)="onEditEmailConfigurationClick()"
                  i18n="edit outgoing email configuration button label@@editEmailConfigurationButtonLabel"
                >Edit Outgoing Mail Configuration</button>
              </div>
              <div style="margin-top: 10px">
                <a
                  class="btn btn-primary anchor-as-btn"
                  routerLink="/setup/password"
                  i18n="change password account button label|The label inside the actions element group to change the password in the My Account page@@changePasswordFromMyAccountPageButtonLabel"
                >Change password</a>
                <a
                  class="btn btn-primary anchor-as-btn"
                  routerLink="/billing"
                  i18n="billing account button label|The label inside the actions element group to open billing information from the My Account page@@openBillingMyAccountPageButtonLabel"
                >Billing</a>
                <a
                  class="btn btn-primary anchor-as-btn"
                  routerLink="/setup/pbiconnection"
                  i18n="setup powerbi connection account button label|The label inside the actions element group to open the powerbi connection wizard in the My Account page@@powerbiConnectionWizardFromMyAccountPageButtonLabel"
                >Setup Power BI Connection</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</section>
